<template>
  <div class="event_code_cla">
    <div class="tab-cla">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="$t('sysOption.accEventType')"
          name="acc"
        ></el-tab-pane>
        <el-tab-pane
          :label="$t('sysOption.deviceParamsType')"
          name="device"
        ></el-tab-pane>
      </el-tabs>
    </div>
    <accEvent v-if="activeName === 'acc'"></accEvent>
    <deviceParams v-if="activeName === 'device'"></deviceParams>
  </div>
</template>

<script>
import accEvent from './accDevice/accEvent'
import deviceParams from './accDevice/deviceParams'

export default {
  components: {
    accEvent,
    deviceParams
  },
  data() {
    return {
      activeName: 'acc'
    }
  },
  methods: {
    handleClick() {}
  },
  mounted() {}
}
</script>

<style scoped lang="less">
@import '~@/styles/var.less';
.event_code_cla {
  .header_tool_cla {
    /deep/ .el-tabs__header {
      margin: 0 0 3px 0;
    }
  }
  .black_panel_cla {
    min-height: 500px;
  }
  /deep/.el-tabs__nav-wrap {
    &::after {
      display: none;
    }
  }
  .tab-cla {
    position: relative;
    height: 40px;
    line-height: 40px;
    background: #fff;
    border-radius: 2px;
    padding: 10px;
  }

  .top-tab-cla {
    padding: 5px 15px;
    line-height: 1.5;
    cursor: pointer;
  }
  .checked {
    color: @themeColor;
    border-bottom: 2px solid;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/sysOptions/sysEventCode.vue